import type { ChangePasswordInput, LoginInput, UserPublic } from '@container-system/shared';
import { apiRequest } from './client';

export function login(input: LoginInput) {
  return apiRequest<{ user: UserPublic }>('/api/auth/login', { method: 'POST', body: JSON.stringify(input) });
}

export function logout() {
  return apiRequest<null>('/api/auth/logout', { method: 'POST' });
}

export function fetchMe() {
  return apiRequest<{ user: UserPublic }>('/api/auth/me');
}

export function changePassword(input: ChangePasswordInput) {
  return apiRequest<null>('/api/auth/change-password', { method: 'POST', body: JSON.stringify(input) });
}
